// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"355":"CreditSlider","544":"EducationPrograms","689":"EducationProgram","763":"Search"}[chunkId] + "." + {"355":"788dc911","544":"2623bc00","689":"4095de06","763":"7c67b762"}[chunkId] + ".js";
};